!function (t, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : ((t = t || self).index = t.index || {}, t.index.js = n());
}(this, function () {
  "use strict";

  function t(n) {
    return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(n);
  }
  function n(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function e(t, n) {
    for (var e = 0; e < n.length; e++) {
      var r = n[e];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function r(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  }
  function o(t, n) {
    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), n && a(t, n);
  }
  function i(t) {
    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function a(t, n) {
    return (a = Object.setPrototypeOf || function (t, n) {
      return t.__proto__ = n, t;
    })(t, n);
  }
  function c() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }
  function u(t, n, e) {
    return (u = c() ? Reflect.construct : function (t, n, e) {
      var r = [null];
      r.push.apply(r, n);
      var o = new (Function.bind.apply(t, r))();
      return e && a(o, e.prototype), o;
    }).apply(null, arguments);
  }
  function f(t) {
    var n = "function" == typeof Map ? new Map() : void 0;
    return (f = function f(t) {
      if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
      var e;
      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== n) {
        if (n.has(t)) return n.get(t);
        n.set(t, r);
      }
      function r() {
        return u(t, arguments, i(this).constructor);
      }
      return r.prototype = Object.create(t.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), a(r, t);
    })(t);
  }
  function s(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function l(t, n) {
    return !n || "object" != typeof n && "function" != typeof n ? s(t) : n;
  }
  function d(t) {
    var n = c();
    return function () {
      var e,
        r = i(t);
      if (n) {
        var o = i(this).constructor;
        e = Reflect.construct(r, arguments, o);
      } else e = r.apply(this, arguments);
      return l(this, e);
    };
  }
  function _p(t, n) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, n) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
      var e = [],
        r = !0,
        o = !1,
        i = void 0;
      try {
        for (var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (e.push(a.value), !n || e.length !== n); r = !0);
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }
      return e;
    }(t, n) || y(t, n) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function m(t) {
    return function (t) {
      if (Array.isArray(t)) return h(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || y(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function y(t, n) {
    if (t) {
      if ("string" == typeof t) return h(t, n);
      var e = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e ? Array.from(t) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? h(t, n) : void 0;
    }
  }
  function h(t, n) {
    (null == n || n > t.length) && (n = t.length);
    for (var e = 0, r = new Array(n); e < n; e++) r[e] = t[e];
    return r;
  }
  function b() {}
  function v(t) {
    return t();
  }
  function g() {
    return Object.create(null);
  }
  function _(t) {
    t.forEach(v);
  }
  function $(t) {
    return "function" == typeof t;
  }
  function k(n, e) {
    return n != n ? e == e : n !== e || n && "object" === t(n) || "function" == typeof n;
  }
  function E(t, n) {
    t.appendChild(n);
  }
  function w(t, n, e) {
    t.insertBefore(n, e || null);
  }
  function x(t) {
    t.parentNode.removeChild(t);
  }
  function O(t) {
    return document.createElement(t);
  }
  function A(t) {
    return document.createTextNode(t);
  }
  function S() {
    return A(" ");
  }
  function j(t, n, e) {
    null == e ? t.removeAttribute(n) : t.getAttribute(n) !== e && t.setAttribute(n, e);
  }
  function T(t) {
    return Array.from(t.childNodes);
  }
  function C(t) {
    var n,
      e = {},
      r = function (t, n) {
        var e;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (Array.isArray(t) || (e = y(t)) || n && t && "number" == typeof t.length) {
            e && (t = e);
            var r = 0,
              o = function o() {};
            return {
              s: o,
              n: function n() {
                return r >= t.length ? {
                  done: !0
                } : {
                  done: !1,
                  value: t[r++]
                };
              },
              e: function e(t) {
                throw t;
              },
              f: o
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var i,
          a = !0,
          c = !1;
        return {
          s: function s() {
            e = t[Symbol.iterator]();
          },
          n: function n() {
            var t = e.next();
            return a = t.done, t;
          },
          e: function e(t) {
            c = !0, i = t;
          },
          f: function f() {
            try {
              a || null == e.return || e.return();
            } finally {
              if (c) throw i;
            }
          }
        };
      }(t);
    try {
      for (r.s(); !(n = r.n()).done;) {
        var o = n.value;
        e[o.name] = o.value;
      }
    } catch (t) {
      r.e(t);
    } finally {
      r.f();
    }
    return e;
  }
  var M;
  function I(t) {
    M = t;
  }
  var R = [],
    P = [],
    L = [],
    N = [],
    z = Promise.resolve(),
    D = !1;
  function H(t) {
    L.push(t);
  }
  var K = !1,
    X = new Set();
  function U() {
    if (!K) {
      K = !0;
      do {
        for (var t = 0; t < R.length; t += 1) {
          var n = R[t];
          I(n), Y(n.$$);
        }
        for (I(null), R.length = 0; P.length;) P.pop()();
        for (var e = 0; e < L.length; e += 1) {
          var r = L[e];
          X.has(r) || (X.add(r), r());
        }
        L.length = 0;
      } while (R.length);
      for (; N.length;) N.pop()();
      D = !1, K = !1, X.clear();
    }
  }
  function Y(t) {
    if (null !== t.fragment) {
      t.update(), _(t.before_update);
      var n = t.dirty;
      t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, n), t.after_update.forEach(H);
    }
  }
  var Q,
    q = new Set();
  function F(t, n) {
    t && t.i && (q.delete(t), t.i(n));
  }
  function J(t, n, e) {
    var r = t.$$,
      o = r.fragment,
      i = r.on_mount,
      a = r.on_destroy,
      c = r.after_update;
    o && o.m(n, e), H(function () {
      var n = i.map(v).filter($);
      a ? a.push.apply(a, m(n)) : _(n), t.$$.on_mount = [];
    }), c.forEach(H);
  }
  function V(t, n) {
    -1 === t.$$.dirty[0] && (R.push(t), D || (D = !0, z.then(U)), t.$$.dirty.fill(0)), t.$$.dirty[n / 31 | 0] |= 1 << n % 31;
  }
  "function" == typeof HTMLElement && (Q = function (t) {
    o(i, t);
    var e = d(i);
    function i() {
      var t;
      return n(this, i), (t = e.call(this)).attachShadow({
        mode: "open"
      }), t;
    }
    return r(i, [{
      key: "connectedCallback",
      value: function value() {
        for (var t in this.$$.slotted) this.appendChild(this.$$.slotted[t]);
      }
    }, {
      key: "attributeChangedCallback",
      value: function value(t, n, e) {
        this[t] = e;
      }
    }, {
      key: "$destroy",
      value: function value() {
        var t, n;
        t = 1, null !== (n = this.$$).fragment && (_(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []), this.$destroy = b;
      }
    }, {
      key: "$on",
      value: function value(t, n) {
        var e = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return e.push(n), function () {
          var t = e.indexOf(n);
          -1 !== t && e.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function value(t) {
        var n;
        this.$$set && (n = t, 0 !== Object.keys(n).length) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]), i;
  }(f(HTMLElement)));
  var B = function B(t) {
    var n = "".concat(t, "="),
      e = document.cookie.split(";");
    for (var r in e) if (0 === e[r].trim().indexOf(n)) return !0;
    return !1;
  };
  function G(t) {
    var n, e, r, o, i, a, c;
    return {
      c: function c() {
        n = O("div"), e = O("div"), (r = O("p")).innerHTML = 'En este portal utilizamos <b class="">“cookies”</b> propias y de terceros para gestionar el portal, elaborar información estadística, optimizar la funcionalidad del sitio y mostrar publicidad relacionada con sus preferencias a través del análisis de la navegación. Puede conocer cómo deshabilitarlas u obtener <a href="/politicas-privacidad" target="_blank" class="container-cookies__link">más información aquí.</a>', o = S(), (i = O("button")).textContent = "Acepto", j(r, "class", "m-0 container-cookies__description mr-md-5 py-2"), j(i, "class", "button container-cookies__button my-2"), j(e, "class", "container d-flex align-items-start align-items-md-center  flex-md-row flex-column"), j(n, "class", "container-cookies d-flex align-items-center");
      },
      m: function m(u, f) {
        var s, l, d, p;
        w(u, n, f), E(n, e), E(e, r), E(e, o), E(e, i), t[4](n), a || (s = i, l = "click", d = t[2], s.addEventListener(l, d, p), c = function c() {
          return s.removeEventListener(l, d, p);
        }, a = !0);
      },
      p: b,
      d: function d(e) {
        e && x(n), t[4](null), a = !1, c();
      }
    };
  }
  function W(t) {
    var n,
      e,
      r,
      o = !t[1] && G(t);
    return {
      c: function c() {
        n = O("link"), e = S(), o && o.c(), r = A(""), this.c = b, j(n, "rel", "stylesheet"), j(n, "href", "https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"), j(n, "integrity", "sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"), j(n, "crossorigin", "anonymous");
      },
      m: function m(t, i) {
        w(t, n, i), w(t, e, i), o && o.m(t, i), w(t, r, i);
      },
      p: function p(t, n) {
        var e = _p(n, 1)[0];
        t[1] ? o && (o.d(1), o = null) : o ? o.p(t, e) : ((o = G(t)).c(), o.m(r.parentNode, r));
      },
      i: b,
      o: b,
      d: function d(t) {
        t && x(n), t && x(e), o && o.d(t), t && x(r);
      }
    };
  }
  function Z(t, n, e) {
    var r;
    !function (t) {
      t.COOKIE_NAME = "cookie_suraenlineacom", t.COOKIE_VALUE = "Acepto", t[t.DAYS_TO_EXPIRE = 30] = "DAYS_TO_EXPIRE";
    }(r || (r = {}));
    var o,
      i,
      a = n.customstyles;
    i = B(r.COOKIE_NAME);
    return t.$$set = function (t) {
      "customstyles" in t && e(3, a = t.customstyles);
    }, t.$$.update = function () {
      9 & t.$$.dirty && a && function (t, n) {
        var e = document.createElement("style");
        e.innerHTML = t, n.appendChild(e);
      }(a, o);
    }, [o, i, function () {
      var t, n, o, a;
      t = r.COOKIE_NAME, n = r.COOKIE_VALUE, o = r.DAYS_TO_EXPIRE, (a = new Date()).setTime(a.getTime() + 24 * o * 60 * 60 * 1e3), document.cookie = "".concat(t, "=").concat(n, "; path=/; expires=").concat(a.toGMTString(), ";"), e(1, i = B(r.COOKIE_NAME));
    }, a, function (t) {
      P[t ? "unshift" : "push"](function () {
        e(0, o = t);
      });
    }];
  }
  var tt = function (t) {
    o(i, t);
    var e = d(i);
    function i(t) {
      var r;
      return n(this, i), (r = e.call(this)).shadowRoot.innerHTML = "<style>.container-cookies{position:fixed;right:0;bottom:0;left:0;background-color:#00AEC7;box-shadow:0 .25rem .375rem 0 #00000029;border-top-right-radius:1.875rem;border-top-left-radius:1.875rem;overflow:hidden;z-index:1050}.container-cookies__description{color:#fff;font-size:0.6875rem}@media(min-width: 48em){.container-cookies__description{font-size:0.875rem}}.container-cookies__button{background-color:#fff;border:0;border-radius:1.25rem;color:#00AEC7;font-size:0.875rem;padding:0.3rem 1.9rem}@media(min-width: 48em){.container-cookies__button{font-size:1.125rem;padding:0.4rem 2.6rem}}.container-cookies__button:focus{outline:none}.container-cookies__link{color:#fff;text-decoration:underline;font-weight:600}.container-cookies__link:hover{color:#fff}</style>", function (t, n, e, r, o, i) {
        var a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : [-1],
          c = M;
        I(t);
        var u = n.props || {},
          f = t.$$ = {
            fragment: null,
            ctx: null,
            props: i,
            update: b,
            not_equal: o,
            bound: g(),
            on_mount: [],
            on_destroy: [],
            before_update: [],
            after_update: [],
            context: new Map(c ? c.$$.context : []),
            callbacks: g(),
            dirty: a,
            skip_bound: !1
          },
          s = !1;
        if (f.ctx = e ? e(t, u, function (n, e) {
          var r = !(arguments.length <= 2) && arguments.length - 2 ? arguments.length <= 2 ? void 0 : arguments[2] : e;
          return f.ctx && o(f.ctx[n], f.ctx[n] = r) && (!f.skip_bound && f.bound[n] && f.bound[n](r), s && V(t, n)), e;
        }) : [], f.update(), s = !0, _(f.before_update), f.fragment = !!r && r(f.ctx), n.target) {
          if (n.hydrate) {
            var l = T(n.target);
            f.fragment && f.fragment.l(l), l.forEach(x);
          } else f.fragment && f.fragment.c();
          n.intro && F(t.$$.fragment), J(t, n.target, n.anchor), U();
        }
        I(c);
      }(s(r), {
        target: r.shadowRoot,
        props: C(r.attributes)
      }, Z, W, k, {
        customstyles: 3
      }), t && (t.target && w(t.target, s(r), t.anchor), t.props && (r.$set(t.props), U())), r;
    }
    return r(i, [{
      key: "customstyles",
      get: function get() {
        return this.$$.ctx[3];
      },
      set: function set(t) {
        this.$set({
          customstyles: t
        }), U();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["customstyles"];
      }
    }]), i;
  }(Q);
  return customElements.define("sura-cookie", tt), tt;
});